/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateMatrixCarePatient201ResponseData } from './CreateMatrixCarePatient201ResponseData';
import {
    CreateMatrixCarePatient201ResponseDataFromJSON,
    CreateMatrixCarePatient201ResponseDataFromJSONTyped,
    CreateMatrixCarePatient201ResponseDataToJSON,
    CreateMatrixCarePatient201ResponseDataToJSONTyped,
} from './CreateMatrixCarePatient201ResponseData';

/**
 * 
 * @export
 * @interface CreateMatrixCarePatient201Response
 */
export interface CreateMatrixCarePatient201Response {
    /**
     * 
     */
    data?: CreateMatrixCarePatient201ResponseData;
}

/**
 * Check if a given object implements the CreateMatrixCarePatient201Response interface.
 */
export function instanceOfCreateMatrixCarePatient201Response(value: object): value is CreateMatrixCarePatient201Response {
    return true;
}

export function CreateMatrixCarePatient201ResponseFromJSON(json: any): CreateMatrixCarePatient201Response {
    return CreateMatrixCarePatient201ResponseFromJSONTyped(json, false);
}

export function CreateMatrixCarePatient201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMatrixCarePatient201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CreateMatrixCarePatient201ResponseDataFromJSON(json['data']),
    };
}

export function CreateMatrixCarePatient201ResponseToJSON(json: any): CreateMatrixCarePatient201Response {
    return CreateMatrixCarePatient201ResponseToJSONTyped(json, false);
}

export function CreateMatrixCarePatient201ResponseToJSONTyped(value?: CreateMatrixCarePatient201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreateMatrixCarePatient201ResponseDataToJSON(value['data']),
    };
}

